import React, { useCallback, useEffect, useMemo, useState } from 'react';
import b_ from 'b_';
import './styles.scss';
import {Spin, Table, Typography} from 'antd';
import useTable from '../../../Utils/useTable';
import { engineStatusSubscrFetch } from '../../../Reducers/engineStatus';
import Filters from '../Filters';
import SubscrFilters from './SubscrFilters';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getCurrentDates } from '../../../Utils/dates';
import { ScheduleOutlined } from '@ant-design/icons';

const b = b_.lock('StatusTable');

function TableSubscr() {

  const dispatch = useDispatch();

  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [curFilters, setCurFilters] = useState({ dates: getCurrentDates() });

  useEffect(() => {
    setLoading(true)
    dispatch(engineStatusSubscrFetch(curFilters.dates))
    .then((res) => {
      setList(res)
    })
    .catch((e) => {
      console.log(`Error fetching: ${e}`)
    })
    .finally(() => {
      setLoading(false)
    })
}, [curFilters, dispatch]);

// const { payload, isLoading } = useSelector((state) => state.engineStatus.subscr, shallowEqual)

// const list = useMemo(() => payload?.list || [], [payload]);

// console.log(`LIST: ${JSON.stringify(list)}`)

  // const {
  //   list,
  //   isLoading,
  //   filters,
  //   onFilter
  // } = useTable(state => state.engineStatus.subscr, engineStatusSubscrFetch);

  const rowClassName = (record) => {
    if (record.name === 'TOTAL') {
      return 'highlighted-row';
    }
    return '';
  };

  const GetColumns = useCallback(() => {
    return [
        { 
          dataIndex: "name",
          title: "Group",
          align: "center",
          width: 100,
        },
            { 
              title: "Subscr",
              align: "center",
              dataIndex: "subscrCount",
              render: (subscrCount) => (
                      <div className={b('col')}>
                        {subscrCount}
                      </div>
                    )},

              { 
              title: "Unsubscr",
              align: "center",
              dataIndex: "unsubscrCount",
              render: (subscrCount) => (
                      <div className={b('col')}>
                        {subscrCount}
                      </div>
                    )},
    ]
  }, [list])

  const [columns, setColumns] = useState(GetColumns());
  const [updatedList, setUpdatedList] = useState([]);

  useEffect(() => {
    setColumns(GetColumns())
}, [list, GetColumns])

useEffect(() => {
    const updatedList = 
      list.map((item) => {
        if (item.name !== 'ALL' && item.isCurrency) {
          const updatedItem = { ...item };
          updatedItem.subscrCount = item.subscrCount;
          updatedItem.unsubscrCount = item.unsubscrCount;
          return updatedItem;
        }
        return item;
      })
    
    setColumns(GetColumns());
    setUpdatedList(updatedList)
      
    const updatedSum = calculateSum(updatedList);
    setUpdatedList((prev) => [...prev, updatedSum]);
}, [list]);

const calculateSum = useCallback((listToUpdate) => {
  const sum = {
    name: 'TOTAL',
    subscrCount: 0,
    unsubscrCount: 0
  };

  listToUpdate.forEach(item => {
    if (item.name !== 'ALL') {
      sum.subscrCount += item.subscrCount;
      sum.unsubscrCount += item.unsubscrCount;
    }
  });

  return sum;
}, [list]);

const filteredList = updatedList.filter(item => item.name !== 'ALL');


  return (
    <div className='SubscrTable'>
    <Typography.Title level={4}><ScheduleOutlined /> Subscriptions count</Typography.Title>
    <Filters curFilters={curFilters} setCurFilters={setCurFilters}/>
  <Table 
        rowKey="name"
        bordered
        className={b('table')}
        dataSource={filteredList}
        pagination={false}
        columns={columns}
        loading={loading}
        size="small"
        scroll={{ x: "max-content" }}
        rowClassName={rowClassName}
  />
  </div>
  );
}

export default TableSubscr;
